export default __webpack_public_path__ + "static/media/sticker-os.74f3a15c.png";